import { Buffer } from 'buffer';

var setupBufferPolyFills = () => {
	window.Buffer = Buffer;
}

export default setupBufferPolyFills;